export const getConfig = () => {
  const windowEnv = typeof window !== 'undefined' ? window.env : undefined;
  const metaEnv = import.meta.env;

  return {
  VITE_DASHBOARD_API_URL: windowEnv?.VITE_DASHBOARD_API_URL || metaEnv.VITE_DASHBOARD_API_URL || "http://localhost:4000",
  VITE_CLIENT_ID: windowEnv?.VITE_CLIENT_ID || metaEnv.VITE_CLIENT_ID || "",
  VITE_SDK_CLIENT_ID: windowEnv?.VITE_SDK_CLIENT_ID || metaEnv.VITE_SDK_CLIENT_ID || "",
  VITE_YOUZU_SDK_URL: windowEnv?.VITE_YOUZU_SDK_URL || metaEnv.VITE_YOUZU_SDK_URL || "",
  VITE_ROOM_VISUALIZE_SDK_URL: windowEnv?.VITE_ROOM_VISUALIZE_SDK_URL || metaEnv.VITE_ROOM_VISUALIZE_SDK_URL || "",
  VITE_YOUZU_API_URL: windowEnv?.VITE_YOUZU_API_URL || metaEnv.VITE_YOUZU_API_URL || "https://platform-api.youzu.ai",
};
};
